import { render, staticRenderFns } from "./StudentTransactions.vue?vue&type=template&id=7471d8da&"
import script from "./StudentTransactions.vue?vue&type=script&lang=js&"
export * from "./StudentTransactions.vue?vue&type=script&lang=js&"
import style0 from "./StudentTransactions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports